import { render, staticRenderFns } from "./SettingUpdateall.vue?vue&type=template&id=704591cd"
import script from "./SettingUpdateall.vue?vue&type=script&lang=js"
export * from "./SettingUpdateall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports